import { render, staticRenderFns } from "./MiladyBarChart.vue?vue&type=template&id=aec88bbc&"
import script from "./MiladyBarChart.vue?vue&type=script&lang=js&"
export * from "./MiladyBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports